/**
 * 数据存储
 */
export const STORE_AREA_INFO_KEY = 'info'
